/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint max-lines: ["error", 600]*/
/* eslint-disable no-lonely-if */
import addressTypeOptions from '@/mixins/crs/addressTypeOptions';
import countriesOptions from '@/mixins/countriesOptions';
import crsIndicatorOptions from '@/mixins/crs/crsIndicatorOptions';
import formatData from '@/mixins/formatData';
import DraftData from '@/components/draft-data';
import keyed from '@/mixins/keyed';
import typeNameOptions from '@/mixins/crs/typeNameOptions';
import Validations from '@/mixins/validations';


export default {

    /**
     * Nombre del componente
     */
    name: 'CrsData',

    components: {
        DraftData
    },

    mixins: [
        countriesOptions,
        formatData,
        keyed,
        Validations,
        addressTypeOptions,
        crsIndicatorOptions,
        typeNameOptions
    ],

    /**
     * Datos del componente
     * @return {Object} Data del componente
     */
    data() {
        return {
            collapsed: true,
            crsDataEdit: false,
            editingCrsUuid: null,
            hasCRSData: false,
            isTinValid: true,
            isLoading: false,
            formatDataRules: () => ({
                'key_tin_issuer_country': [value => (value ? { key: value, name: this.$t(`countries.${value}`) } : null)]
            })
        };
    },
    props: {
        uuid: {
            type: String,
            required: false
        },
        data: {
            type: [Object, Array],
            required: false
        },
        creation: {
            type: Boolean,
            required: false,
            default: false
        },
        existing: {
            type: Boolean,
            required: false,
            default: false
        },
        intervenerStatus: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        data: {
            immediate: true,
            /**
             * Update formattedData when data changes
             */
            handler() {
                this.formatData();
                this.modifiedData = {};
                this.editingCrsUuid = null;
            }
        }
    },
    methods: {

        /**
         * Formatea la data CRS manteniendo un objeto en alta y una lista en detalle.
         */
        formatData() {
            if (!this.data) {
                this.formattedData = this.creation ? {} : [];
                return;
            }

            if (Array.isArray(this.data)) {
                this.formattedData = this.data.map(item => this.formatCrsItem(item));
                return;
            }

            this.formattedData = this.formatCrsItem(this.data);
        },

        /**
         * @param {Object} item CRS item
         * @return {Object} formatted CRS item
         */
        formatCrsItem(item) {
            const rules = this.formatDataRules();
            return Object.keys(item || {}).reduce((acc, key) => {
                if (rules[key]) {
                    const itemRules = rules[key].slice();
                    const rule = itemRules.pop();
                    let field = key;
                    if (itemRules.length > 0) {
                        field = itemRules.pop();
                    }
                    acc[field] = rule(item[key], acc);
                } else {
                    acc[key] = JSON.parse(JSON.stringify(item[key]));
                }
                return acc;
            }, {});
        },

        /**
         * @return {Array} CRS items
         */
        crsDataItems() {
            if (Array.isArray(this.formattedData)) {
                return this.formattedData;
            }

            if (this.formattedData && Object.keys(this.formattedData).length) {
                return [this.formattedData];
            }

            return this.creation ? [this.formattedData] : [];
        },

        /**
         * @param {Object} crsItem CRS item
         * @return {String} CRS key
         */
        crsKey(crsItem = {}) {
            return crsItem.uuid || this.key;
        },

        /**
         * @param {Object} crsItem CRS item
         * @return {Boolean} Edit state
         */
        isCrsDataEdit(crsItem = {}) {
            return this.creation ? this.crsDataEdit : this.editingCrsUuid === crsItem.uuid;
        },

        /**
         * @param {Boolean} edit allow edit or not
         * @param {Event} e Evento del form
         * @param {Object} crsItem CRS item
         */
        editCrsData(edit, e, crsItem = {}) {
            e.preventDefault();
            e.stopPropagation();

            this.isTinValid = true;

            if (this.creation) return this.crsDataEdit = edit;
            
            this.editingCrsUuid = edit ? crsItem.uuid : null;
            this.modifiedData = edit && crsItem.uuid ? { uuid: crsItem.uuid } : {};
            

            if (edit && !this.collapsed) {
                this.$root.$emit('bv::toggle::collapse', 'collapse-crs-data');
            }

            if (!edit) {
                this.formatData();
                this.modifiedData = {};
            }
        },

        /**
         * Validate CRS data
         * @param {Object} crsItem CRS item
         * @return {Boolean} valid or not
         */
        validateData(crsItem = {}) {
            this.cleanErrors();

            const requiredProperties = [
                'key_tin_issuer_country',
                'tin_code'
            ];

            return Promise.resolve(true).then(valid => {
                requiredProperties.forEach(required => {
                    if (!crsItem[required]) {
                        valid = false;
                        const ref = this.$refs[`${required}-${this.crsKey(crsItem)}`];
                        const element = Array.isArray(ref) ? ref[0] : ref;
                        if (element && element.$el) {
                            element.$el.classList.add('creation-error');
                        }
                    }
                });
                return valid;
            });
        },

        /**
         * Funcion generica para guardar los elementos editados
         * @param {*} field Campo editado
         * @param {*} val Valor
         * @param {Object} crsItem CRS item
         */
        setValueEdited(field, val, crsItem = {}) {
            const modifiedData = Object.assign(
                {},
                this.creation ? {} : { uuid: crsItem.uuid },
                this.modifiedData
            );

            switch (field) {
                case 'key_tin_issuer_country':
                    modifiedData['key_tin_issuer_country'] = val.key;
                    break;
                default:
                    modifiedData[field] = (typeof val === 'object')
                        ? val.key
                        : val;
                    break;
            }

            this.modifiedData = modifiedData;
        },

        /**
         * @param {Object} crsItem CRS item
         * @return {Promise} TIN validation request
         */
        validateTinNumber(crsItem = {}) {
            const issuerCountry = this.modifiedData.key_tin_issuer_country
                || (crsItem.key_tin_issuer_country && crsItem.key_tin_issuer_country.key);

            return this.$intervenersService.validateTinNumber(
                issuerCountry.substring(0, 2),
                this.modifiedData.tin_code || crsItem.tin_code
            );
        },

        /**
         * @param {Object} crsItem CRS item
         */
        handleInvalidTin(crsItem = {}) {
            this.isTinValid = false;
            const ref = this.$refs[`tin_code-${this.crsKey(crsItem)}`];
            const element = Array.isArray(ref) ? ref[0] : ref;
            if (element && element.$el) {
                element.$el.classList.add('creation-error');
            }
        },

        /**
         * @param {Event} e FormEvent
         * @param {Object} crsItem CRS item
         */
        onSubmit(e, crsItem = {}) {
            e.preventDefault();

            const shouldValidateTin = this.modifiedData.hasOwnProperty('tin_code')
                || this.modifiedData.hasOwnProperty('key_tin_issuer_country');

            this.isLoading = true;
            this.validateData(crsItem)
                .then(valid => {
                    if (!valid) {
                        this.isLoading = false;
                        this.$toast.error('Error en datos de crs', 'Revisa los campos marcados en rojo');
                        return false;
                    }

                    return shouldValidateTin ? this.validateTinNumber(crsItem) : null;
                })
                .then(response => {
                    if (response === false) {
                        return;
                    }

                    if (response && !response.data.isTinValid) {
                        this.handleInvalidTin(crsItem);
                        this.isLoading = false;
                        this.$toast.error('Error en datos de crs', 'Revisa los campos marcados en rojo');
                        return;
                    }
                    Promise.all([
                        this.$intervenersService.updateIntervenerCRS(this.uuid, this.modifiedData)
                    ])
                        .then(res => {
                            const updatedCrs = res[0].data.intervener_crs;
                            this.$emit('saved', updatedCrs || crsItem);
                            this.$root.$emit('refresh_intervener');
                            this.crsDataEdit = false;
                            this.editingCrsUuid = null;
                            this.modifiedData = {};
                            this.$toast.success(`Guardado`, `Datos modificados con éxito.`);
                        })
                        .catch(err => {
                            this.$toast.error(err.name, err.message);
                            this.formatData();
                            this.crsDataEdit = false;
                            this.editingCrsUuid = null;
                            this.modifiedData = {};
                        })
                        .finally(() => this.isLoading = false);
                })
                .catch(err => {
                    console.error(err);
                    this.$toast.error(err.name, err.message);
                    this.isLoading = false;
                });
        }

    },

    /**
     * @override
     */
    beforeMount() {

        if (this.creation) {
            this.crsDataEdit = !this.existing;
        }

    }
};
